webpackJsonp([171],{

/***/ 1307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOrderStatTable_vue__ = __webpack_require__(3075);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a34f1dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOrderStatTable_vue__ = __webpack_require__(5756);
function injectStyle (ssrContext) {
  __webpack_require__(5754)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOrderStatTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a34f1dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOrderStatTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    value: {
      type: Array,
      default: []
    },
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      initialize: null,
      cascaderAreas: []
    };
  },

  computed: {},
  watch: {
    value: function value() {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.currentValue = this.value;
        // 加载value中的市区
        this.initialize.then(this.loadCityAndDistrict);
      }
      if (this.disabled) {
        this.loadCityAndDistrict();
      }
    },
    currentValue: function currentValue() {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.$emit('input', this.currentValue);
      }
    }
  },
  created: function created() {
    var _this = this;

    // 初始化数据
    this.initialize = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!_this.cascaderAreas.length) {
        request('getProvinces').then(function (_ref) {
          var data = _ref.data;

          _this.setProvinces(data);
          resolve();
        }, reject);
      } else {
        resolve();
      }
    });
    // 加载value中的市区
    this.initialize.then(this.loadCityAndDistrict);
  },
  mounted: function mounted() {},

  methods: {
    loadCityAndDistrict: function loadCityAndDistrict() {
      var _this2 = this;

      var value = this.currentValue;
      if (value.length >= 1) {
        this.handleAreaChange(value.slice(0, 1)).then(function () {
          if (value.length > 2) {
            _this2.handleAreaChange(value.slice(0, 2));
          }
        });
      }
    },
    setProvinces: function setProvinces(data) {
      this.cascaderAreas = data.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name;

        return {
          name: name,
          id: id,
          children: []
        };
      });
    },
    setCities: function setCities(provinceIndex) {
      var cascaderAreas = this.cascaderAreas;
      var province = cascaderAreas[provinceIndex];
      return request.alert('getCities', { pid: province.id }).then(function (_ref3) {
        var data = _ref3.data;

        // 设置城市列表
        cascaderAreas[provinceIndex].children = data.map(function (_ref4) {
          var id = _ref4.id,
              name = _ref4.name;

          return {
            name: name,
            id: id,
            children: []
          };
        });
      });
    },
    setDistricts: function setDistricts(provinceIndex, cityIndex) {
      var cascaderAreas = this.cascaderAreas;
      var city = cascaderAreas[provinceIndex].children[cityIndex];
      return request.alert('getDistricts', { pid: city.id }).then(function (_ref5) {
        var data = _ref5.data;

        // 设置县区列表
        cascaderAreas[provinceIndex].children[cityIndex].children = data.map(function (_ref6) {
          var id = _ref6.id,
              name = _ref6.name;

          return { name: name, id: id };
        });
      });
    },
    findProvince: function findProvince(id) {
      return _.findIndex(this.cascaderAreas, { id: id });
    },
    findCity: function findCity(provinceIndex, id) {
      return _.findIndex(this.cascaderAreas[provinceIndex].children, { id: id });
    },
    handleAreaChange: function handleAreaChange(selected) {
      var promise = null;
      var provinceIndex = this.findProvince(selected[0]);
      var province = this.cascaderAreas[provinceIndex];
      switch (selected.length) {
        case 1:
          // 不存在该省份的城市列表则请求获取
          if (!province.children.length) {
            promise = this.setCities(provinceIndex);
          }
          break;
        case 2:
          var cityIndex = this.findCity(provinceIndex, selected[1]);
          var city = province.children[cityIndex];
          // 不存在该城市的县区列表则请求获取
          if (!city.children.length) {
            promise = this.setDistricts(provinceIndex, cityIndex);
          }
          break;
      }
      this.$emit('change', this.currentValue);
      return promise;
    }
  }
});

/***/ }),

/***/ 1531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CascaderDistrict_vue__ = __webpack_require__(1456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50134b28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CascaderDistrict_vue__ = __webpack_require__(1538);
function injectStyle (ssrContext) {
  __webpack_require__(1532)
  __webpack_require__(1534)
  this["$style"] = __webpack_require__(1536)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50134b28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CascaderDistrict_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50134b28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CascaderDistrict_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6dd86c40", content, true, {});

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("05223b44", content, true, {});

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("701f92b6", content, true, {});

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"size":_vm.size,"disabled":_vm.disabled,"options":_vm.cascaderAreas,"props":{value: 'id',label: 'name'},"placeholder":_vm.placeholder,"filterable":"","clearable":_vm.clearable,"change-on-select":""},on:{"change":_vm.handleAreaChange,"focus":function (_) { return _vm.$emit('focus', _); }},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableFields: [{ prop: 'userid', label: '用户ID', width: 100 }, { prop: 'realname', label: '用户真实姓名', width: 120 }, { prop: 'cellphone', label: '用户手机号', width: 150 }, { prop: 'usertype', label: '用户类型', width: 100 }, { prop: 'task_types', label: '任务类型', width: 200 }, { prop: 'tags', label: '标签', width: 200 }, { prop: 'current_location', label: '当前心跳位置', width: 200 }, { prop: 'id_card_location', label: '身份证覆盖位置', width: 200 }, { prop: 'all_approved_rate', label: '综合做单准确率', width: 120 }, { prop: 'order_rank_avg', label: '做单质量(平均分)', width: 150 }, { prop: 'order_canceled_avg', label: '恶意弃单率(%)', width: 120 }, { prop: 'order_canceled_cnt', label: '恶意弃单次数', width: 120 }, { prop: 'order_total_cnt', label: '抢单总次数', width: 120 }, { prop: 'all_approved_cnt', label: '做单数量', width: 100 }, { prop: 'customer_count', label: '参与客户数量', width: 120 }, { prop: 'evidence_types', label: '证据类型', width: 100 }, { prop: 'registertime', label: '注册时间', width: 160 }, { prop: 'last_active_tp', label: '最后活跃时间', width: 160 }, { prop: 'cumulative_bounty', label: '累计做单金额', width: 150 }],
      detailFields: [{ prop: 'userid', label: '用户ID' }, { prop: 'realname', label: '用户真实姓名' }, { prop: 'cellphone', label: '用户手机号' }, { prop: 'usertype', label: '用户类型' }, { prop: 'task_types', label: '任务类型' }, { prop: 'tags', label: '标签', allowToggle: true }, { prop: 'tag_groups', label: '标签组' }, { prop: 'current_location', label: '当前心跳位置' }, { prop: 'id_card_location', label: '身份证覆盖位置' }, { prop: 'order_rank_info', label: '做单质量(平均分)' }, { prop: 'order_canceled_avg', label: '恶意弃单率(%)' }, { prop: 'order_canceled_cnt', label: '恶意弃单次数' }, { prop: 'order_total_cnt', label: '抢单总次数' }, { prop: 'all_approved_cnt', label: '做单(已通过)数量' }, { prop: 'evidence_types', label: '证据类型' }, { prop: 'registertime', label: '注册时间' }, { prop: 'last_active_tp', label: '最后活跃时间' }, { prop: 'cumulative_bounty', label: '累计做单金额(元)' }, { prop: 'customer_count', label: '参与客户数量' }, { prop: 'customer_ids', label: '参与客户列表', allowToggle: true }, { prop: 'order_covered_nonsubmitted_locations', label: '签到未提交工单覆盖', allowToggle: true }, { prop: 'order_covered_rejected_locations', label: '提交未通过工单覆盖', allowToggle: true }, { prop: 'order_covered_approved_locations', label: '审核通过工单覆盖', allowToggle: true }, { prop: 'order_measurement_all_approved_rate', label: '综合做单数据' }]
    };
  }
});

/***/ }),

/***/ 3075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_area_components_CascaderDistrict__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userOrderStat_mixins__ = __webpack_require__(2504);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4__userOrderStat_mixins__["a" /* default */]],
  data: function data() {
    return {
      search: {
        userid: null,
        task_types: [],
        cellphone: null,
        tags: [],
        tag_group: [],
        not_tag_group: [],
        not_tags: [],
        current_location: [],
        id_card_location: [],
        history_order_covered_location: [],
        customer_ids: [],
        evidence_types: [],
        usertype: [],
        not_usertype: ['90'],
        registertime: null,
        history_order_covered_type: null,
        task_type_approved_rate: [null, null],
        all_approved_rate: [null, null],
        order_rank_avg: [null, null],
        order_canceled_avg: [null, null],
        order_canceled_cnt: [null, null],
        all_approved_cnt: [null, null],
        customer_count: [null, null],
        cumulative_bounty: [null, null]
      },
      searchFieldType: {
        task_types: Array
      },
      tagForm: {
        action: null,
        tags: [],
        search_params: {}
      },
      table: [],
      multiSelection: [],
      tagDialogTitle: '',
      selectedCnt: 0,
      tagDialogVisible: false
    };
  },

  components: {
    CascaderDistrict: __WEBPACK_IMPORTED_MODULE_3__views_area_components_CascaderDistrict__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    userOptions: function userOptions(state) {
      return state.users.options;
    },
    userOrderStat: function userOrderStat(state) {
      return state.userOrderStat;
    }
  }), Vuex.mapGetters('order', ['getSortedTaskTypes'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getUserTagTable', 'getUserTagDetail']), {
    getTableData: function getTableData(params) {
      var _this = this;

      return request.common('queryUserOderStatApi', this.prepareParams(params)).then(function (response) {
        response.data.data = response.data.data.map(function (item) {
          var usertype = _this.userOptions.type.find(function (it) {
            return it.value + '' === item.usertype + '';
          });
          item.usertype = _.get(usertype, 'label', item.usertype);
          item.task_types = item.task_types.join(', ');
          item.tags = item.tags.join(', ');
          item.current_location = item.current_location.join('-');
          item.id_card_location = item.id_card_location.join('-');
          item.all_approved_rate = _this.multiplyBy100(_.get(item, 'order_measurement.all.approved_rate', 0), 2, '%');
          item.order_canceled_avg = _this.multiplyBy100(_.get(item, 'order_canceled_avg', 0), 2, '%');
          item.all_approved_cnt = _.get(item, 'order_measurement.all.approved_cnt', 0);
          item.evidence_types = item.evidence_types.map(function (it) {
            return _this.userOrderStat.evidenceTypeMap[it];
          }).join(', ');
          item.last_active_tp = item.last_active_tp === '1970-01-01 00:00:00' ? '-' : item.last_active_tp;
          return item;
        });
        return response;
      });
    },
    resetForm: function resetForm() {
      this.$refs['searchForm'].resetFields();
    },
    exportBySearch: function exportBySearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.tableFields.map(function (item) {
          var prop = item.prop,
              label = item.label,
              rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(item, ['prop', 'label']);

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: prop, text: label }, rest);
        }),
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multiSelection = val;
    },
    openAddTagByIds: function openAddTagByIds() {
      this.tagDialogTitle = '按已选中用户ID来添加标签';
      this.tagDialogVisible = true;
      this.tagForm.action = 'add_tag_by_ids';
      this.tagForm.tags = [];
      this.tagForm.search_params = { userid: this.multiSelection.map(function (item) {
          return item.userid;
        }) };
      this.selectedCnt = this.multiSelection.length;
    },
    openDelTagByIds: function openDelTagByIds() {
      this.tagDialogTitle = '按已选中用户ID来删除标签';
      this.tagDialogVisible = true;
      this.tagForm.action = 'del_tag_by_ids';
      this.tagForm.tags = [];
      this.tagForm.search_params = { userid: this.multiSelection.map(function (item) {
          return item.userid;
        }) };
      this.selectedCnt = this.multiSelection.length;
    },
    openAddTagBySearch: function openAddTagBySearch() {
      this.tagDialogTitle = '按搜索条件来添加标签';
      this.tagForm.action = 'add_tag_by_search';
      this.tagForm.tags = [];
      this.tagForm.search_params = this.prepareParams(this.search);
      this.selectedCnt = this.pagination.total;
      this.tagDialogVisible = true;
    },
    openDelTagBySearch: function openDelTagBySearch() {
      this.tagDialogTitle = '按搜索条件来删除标签';
      this.tagForm.action = 'del_tag_by_search';
      this.tagForm.tags = [];
      this.tagForm.search_params = this.prepareParams(this.search);
      this.selectedCnt = this.pagination.total;
      this.tagDialogVisible = true;
    },
    closeTagDialog: function closeTagDialog() {
      this.tagDialogVisible = false;
      this.tagForm.action = '';
      this.tagForm.tags = [];
      this.tagForm.search_params = {};
    },
    onSubmitTagForm: function onSubmitTagForm() {
      var _this2 = this;

      switch (this.tagForm.action) {
        case 'add_tag_by_ids':
        case 'add_tag_by_search':
          return request.common('userAddTagBySearchApi', _.cloneDeep(this.tagForm)).then(function (_ref) {
            var data = _ref.data;

            _this2.$message.success('按条件新增用户标签任务创建成功');
            _this2.closeTagDialog();
          });
        case 'del_tag_by_ids':
        case 'del_tag_by_search':
          return request.common('userDelTagBySearchApi', _.cloneDeep(this.tagForm)).then(function (_ref2) {
            var data = _ref2.data;

            _this2.$message.success('按条件删除用户标签任务创建成功');
            _this2.closeTagDialog();
          });
        default:
          this.$message.error('错误:未知的 tagForm.action');
      }
    },

    // 任务类型数量不为1的时候,不支持搜索任务做单准确率
    changeTaskTypes: function changeTaskTypes() {
      if (this.search.task_types.length !== 1) {
        this.search.task_type_approved_rate[0] = null;
        this.search.task_type_approved_rate[1] = null;
      }
    },

    // 更换了历史覆盖类型,若清空选项,则需要把 history_order_covered_location 置空
    changeCoveredType: function changeCoveredType() {
      if (!this.search.history_order_covered_type) {
        this.search.history_order_covered_location = [];
      }
    },
    multiplyBy100: function multiplyBy100(num) {
      var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var str = (num * 100).toFixed(digit);
      return Number(str) + suffix;
    },
    prepareParams: function prepareParams(params) {
      var newParams = _.cloneDeep(params);
      if (!!newParams.history_order_covered_type && _.isArray(newParams.history_order_covered_location) && newParams.history_order_covered_location.length > 0) {
        switch (newParams.history_order_covered_type + '') {
          case '1':
            // 签到未提交
            newParams.order_covered_nonsubmitted_locations = newParams.history_order_covered_location;
            break;
          case '2':
            // 提交未通过
            newParams.order_covered_rejected_locations = newParams.history_order_covered_location;
            break;
          case '3':
            // 审核通过
            newParams.order_covered_approved_locations = newParams.history_order_covered_location;
            break;
        }
        delete newParams['history_order_covered_location'];
      }
      return newParams;
    }
  })
});

/***/ }),

/***/ 5754:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5755);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4b0e42ea", content, true, {});

/***/ }),

/***/ 5755:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".ellipsis-cell{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.5}.el-tooltip__popper{max-width:80%}", "", {"version":3,"sources":["/workspace/src/views/user-order-stat/pages/UserOrderStatTable.vue"],"names":[],"mappings":"AACA,eACE,oBAAqB,AACrB,4BAA6B,AAC7B,qBAAsB,AACtB,gBAAiB,AACjB,uBAAwB,AACxB,WAAY,AACZ,eAAiB,CAClB,AAED,oBACE,aAAe,CAChB","file":"UserOrderStatTable.vue","sourcesContent":["\n.ellipsis-cell {\n  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */\n  -webkit-box-orient: vertical; /* 设置伸缩盒子的子元素排列方式为垂直排列 */\n  -webkit-line-clamp: 2; /* 限制显示的行数为2行 */\n  overflow: hidden; /* 超出部分隐藏 */\n  text-overflow: ellipsis; /* 显示省略号 */\n  width: 100%; /* 确保占满单元格宽度 */\n  line-height: 1.5; /* 可根据需要调整行高 */\n}\n/* 可选：调整tooltip样式 */\n.el-tooltip__popper {\n  max-width: 80%; /* 限制tooltip最大宽度，防止内容过长 */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户标签管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"150px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"用户ID","prop":"userid"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入用户ID进行搜索"},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务类型","prop":"task_types"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"未选择时 任务做单准确率 选项将被禁用"},on:{"change":function($event){return _vm.changeTaskTypes()}},model:{value:(_vm.search.task_types),callback:function ($$v) {_vm.$set(_vm.search, "task_types", $$v)},expression:"search.task_types"}},_vm._l((_vm.getSortedTaskTypes),function(item){return (item.value + '' !== '21')?_c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}},[(item.deprecated)?[_c('span',{staticStyle:{"float":"left","color":"#9ba0a5"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc)+"\n                ")])]:[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])]],2):_vm._e()}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"cellphone"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入手机号进行搜索"},model:{value:(_vm.search.cellphone),callback:function ($$v) {_vm.$set(_vm.search, "cellphone", $$v)},expression:"search.cellphone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标签","prop":"tags"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入用户标签关键字搜索(支持多选)","queryParams":{is_group: 0},"query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.search.tags),callback:function ($$v) {_vm.$set(_vm.search, "tags", $$v)},expression:"search.tags"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标签组","prop":"tag_group"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入标签组关键字搜索(支持多选)","queryParams":{is_group: 1},"query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.search.tag_group),callback:function ($$v) {_vm.$set(_vm.search, "tag_group", $$v)},expression:"search.tag_group"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前心跳位置","prop":"current_location"}},[_c('CascaderDistrict',{staticClass:"width-max",attrs:{"clearable":"","changeOnSelect":false},model:{value:(_vm.search.current_location),callback:function ($$v) {_vm.$set(_vm.search, "current_location", $$v)},expression:"search.current_location"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证覆盖位置","prop":"id_card_location"}},[_c('CascaderDistrict',{staticClass:"width-max",attrs:{"clearable":"","changeOnSelect":false},model:{value:(_vm.search.id_card_location),callback:function ($$v) {_vm.$set(_vm.search, "id_card_location", $$v)},expression:"search.id_card_location"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"历史覆盖类型","prop":"history_order_covered_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"未选择时 历史覆盖位置 选项将被禁用"},on:{"change":function($event){return _vm.changeCoveredType()}},model:{value:(_vm.search.history_order_covered_type),callback:function ($$v) {_vm.$set(_vm.search, "history_order_covered_type", $$v)},expression:"search.history_order_covered_type"}},[_c('el-option',{key:"1",attrs:{"label":"签到未提交","value":"1"}}),_vm._v(" "),_c('el-option',{key:"2",attrs:{"label":"提交未通过","value":"2"}}),_vm._v(" "),_c('el-option',{key:"3",attrs:{"label":"审核通过","value":"3"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务做单准确率(%)","prop":"task_type_approved_rate"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":"","disabled":_vm.search.task_types.length !== 1},model:{value:(_vm.search.task_type_approved_rate[0]),callback:function ($$v) {_vm.$set(_vm.search.task_type_approved_rate, 0, $$v)},expression:"search.task_type_approved_rate[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":"","disabled":_vm.search.task_types.length !== 1},model:{value:(_vm.search.task_type_approved_rate[1]),callback:function ($$v) {_vm.$set(_vm.search.task_type_approved_rate, 1, $$v)},expression:"search.task_type_approved_rate[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"历史覆盖位置","prop":"history_order_covered_location"}},[_c('CascaderDistrict',{staticClass:"width-max",attrs:{"disabled":!_vm.search.history_order_covered_type,"clearable":"","changeOnSelect":false},model:{value:(_vm.search.history_order_covered_location),callback:function ($$v) {_vm.$set(_vm.search, "history_order_covered_location", $$v)},expression:"search.history_order_covered_location"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"综合做单准确率(%)","prop":"all_approved_rate"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":""},model:{value:(_vm.search.all_approved_rate[0]),callback:function ($$v) {_vm.$set(_vm.search.all_approved_rate, 0, $$v)},expression:"search.all_approved_rate[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":""},model:{value:(_vm.search.all_approved_rate[1]),callback:function ($$v) {_vm.$set(_vm.search.all_approved_rate, 1, $$v)},expression:"search.all_approved_rate[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"做单质量","prop":"order_rank_avg"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"最低分","clearable":""},model:{value:(_vm.search.order_rank_avg[0]),callback:function ($$v) {_vm.$set(_vm.search.order_rank_avg, 0, $$v)},expression:"search.order_rank_avg[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"最高分","clearable":""},model:{value:(_vm.search.order_rank_avg[1]),callback:function ($$v) {_vm.$set(_vm.search.order_rank_avg, 1, $$v)},expression:"search.order_rank_avg[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"恶意弃单率(%)","prop":"order_canceled_avg"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":""},model:{value:(_vm.search.order_canceled_avg[0]),callback:function ($$v) {_vm.$set(_vm.search.order_canceled_avg, 0, $$v)},expression:"search.order_canceled_avg[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"%","clearable":""},model:{value:(_vm.search.order_canceled_avg[1]),callback:function ($$v) {_vm.$set(_vm.search.order_canceled_avg, 1, $$v)},expression:"search.order_canceled_avg[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"恶意弃单次数","prop":"order_canceled_cnt"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"次","clearable":""},model:{value:(_vm.search.order_canceled_cnt[0]),callback:function ($$v) {_vm.$set(_vm.search.order_canceled_cnt, 0, $$v)},expression:"search.order_canceled_cnt[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"次","clearable":""},model:{value:(_vm.search.order_canceled_cnt[1]),callback:function ($$v) {_vm.$set(_vm.search.order_canceled_cnt, 1, $$v)},expression:"search.order_canceled_cnt[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"做单数量","prop":"all_approved_cnt"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"个","clearable":""},model:{value:(_vm.search.all_approved_cnt[0]),callback:function ($$v) {_vm.$set(_vm.search.all_approved_cnt, 0, $$v)},expression:"search.all_approved_cnt[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"个","clearable":""},model:{value:(_vm.search.all_approved_cnt[1]),callback:function ($$v) {_vm.$set(_vm.search.all_approved_cnt, 1, $$v)},expression:"search.all_approved_cnt[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"参与客户数量","prop":"customer_count"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"个","clearable":""},model:{value:(_vm.search.customer_count[0]),callback:function ($$v) {_vm.$set(_vm.search.customer_count, 0, $$v)},expression:"search.customer_count[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"个","clearable":""},model:{value:(_vm.search.customer_count[1]),callback:function ($$v) {_vm.$set(_vm.search.customer_count, 1, $$v)},expression:"search.customer_count[1]"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"证据类型","prop":"evidence_types"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请选择证据类型"},model:{value:(_vm.search.evidence_types),callback:function ($$v) {_vm.$set(_vm.search, "evidence_types", $$v)},expression:"search.evidence_types"}},_vm._l((_vm.userOrderStat.evidenceTypeMap),function(label,value){return _c('el-option',{key:value + '',attrs:{"label":label,"value":value + ''}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"注册时间","prop":"evidence_types"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","default-time":['00:00:00', '23:59:59'],"align":"center","clearable":""},model:{value:(_vm.search.registertime),callback:function ($$v) {_vm.$set(_vm.search, "registertime", $$v)},expression:"search.registertime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","multiple":"","clearable":""},model:{value:(_vm.search.usertype),callback:function ($$v) {_vm.$set(_vm.search, "usertype", $$v)},expression:"search.usertype"}},_vm._l((_vm.userOptions.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"剔除用户类型","prop":"not_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","multiple":"","clearable":""},model:{value:(_vm.search.not_usertype),callback:function ($$v) {_vm.$set(_vm.search, "not_usertype", $$v)},expression:"search.not_usertype"}},_vm._l((_vm.userOptions.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"剔除标签用户","prop":"not_tags"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入用户标签关键字搜索(支持多选)","query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.search.not_tags),callback:function ($$v) {_vm.$set(_vm.search, "not_tags", $$v)},expression:"search.not_tags"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"剔除标签组","prop":"not_tag_group"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入标签组关键字搜索(支持多选)","queryParams":{is_group: 1},"query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.search.not_tag_group),callback:function ($$v) {_vm.$set(_vm.search, "not_tag_group", $$v)},expression:"search.not_tag_group"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计做单金额","prop":"cumulative_bounty"}},[_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"元","clearable":""},model:{value:(_vm.search.cumulative_bounty[0]),callback:function ($$v) {_vm.$set(_vm.search.cumulative_bounty, 0, $$v)},expression:"search.cumulative_bounty[0]"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"7%","display":"inline-block","text-align":"center"}},[_vm._v(" - ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"45%"},attrs:{"placeholder":"元","clearable":""},model:{value:(_vm.search.cumulative_bounty[1]),callback:function ($$v) {_vm.$set(_vm.search.cumulative_bounty, 1, $$v)},expression:"search.cumulative_bounty[1]"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"medium"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"medium"},on:{"click":function($event){return _vm.resetForm()}}},[_vm._v("重置搜索项\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"medium"},on:{"click":function($event){return _vm.exportBySearch()}}},[_vm._v("导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.multiSelection.length < 1,"size":"mini"},on:{"click":function($event){return _vm.openAddTagByIds()}}},[_vm._v(" 按选中ID添加标签\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","disabled":_vm.multiSelection.length < 1,"size":"mini"},on:{"click":function($event){return _vm.openDelTagByIds()}}},[_vm._v(" 按选中ID删除标签\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.openAddTagBySearch()}}},[_vm._v(" 按搜索条件添加标签\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.openDelTagBySearch()}}},[_vm._v(" 按搜索条件删除标签\n      ")])],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_vm._l((_vm.tableFields),function(attr){return [_c('el-table-column',_vm._b({key:attr.prop,attrs:{"prop":attr.prop},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":scope.row[attr.prop] + '',"placement":"top"}},[_c('div',{staticClass:"ellipsis-cell"},[_vm._v(_vm._s(scope.row[attr.prop]))])])]}}],null,true)},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/user-order-stat/detail/" + (scope.row.userid))}},[_c('el-button',{attrs:{"size":"mini","type":"primary"}},[_vm._v("查看\n            ")])],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[10, 20, 50, 100],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.tagDialogTitle,"visible":_vm.tagDialogVisible,"width":"50%"},on:{"update:visible":function($event){_vm.tagDialogVisible=$event}}},[_c('div',[_vm._v("当前选中了 "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.selectedCnt))]),_vm._v(" 个用户")]),_c('br'),_vm._v(" "),_c('el-form',{ref:"tagForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.tagForm,"label-width":"100px"}},[_c('el-row',{staticClass:"text item"},[_c('el-form-item',{attrs:{"prop":"tags","required":"","label":"标签:"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入用户标签关键字搜索(支持多选)","queryParams":{is_group: 0},"query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.tagForm.tags),callback:function ($$v) {_vm.$set(_vm.tagForm, "tags", $$v)},expression:"tagForm.tags"}})],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.closeTagDialog()}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmitTagForm()}}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user_order_stat_table.5d9ac258e35116939639.js